<template>
    <div class="manage--content">

        <!-- Tiêu đề -->
        <div class="nqt--title" v-if="!mobile">
            <h1>
                <template v-if="data != null && data.userName.search('@') !== -1">{{data.userName.substring(0, data.userName.search('@'))}}</template>
                <template v-if="data != null && data.userName.search('@') == -1">{{data.userName}}</template>
            </h1>
        </div>

        <!-- Nội dung -->

        <!-- Nội dung:Tab -->
        <div class="tab" v-if="!cpnDetail">
            <button :class="{active1: profileTab}" v-on:click="profileTab = true" class="btn-tab">{{$t('manage.detail')}}</button>
            <button :class="{active1: !profileTab}" v-on:click="profileTab = false" class="btn-tab">{{$t('manage.lessons')}}</button>
        </div>


        <div class="top-content" v-show="!showWrongAnswer&&!showWrongExam">
            <h1 class="manage-title-content" v-if="cpnDetail">{{$t('profile.detail_lesson')}}</h1>

            <div class="content__buttons">
                <!-- export certificate -->
                <button class="btn-tast" v-if="cpnDetail" @click="exportCertificate()">
                    <img src="../../../../static/images/icon_export.png" />
                    <span class="nqt-text">{{ $t("studySituationList.certificate") }}</span>
                </button>

                <!-- Back -->
                <button class="btn-tast btn-next-1" v-if="cpnDetail && !mobile" @click="back()">
                    <img src="../../../../static/images/icon-back-1.png" />
                    <span class="nqt-text">{{ $t("common.returnButton") }}</span>
                </button>
            </div>

            <!-- Tìm kiếm -->
            <div class="manage--search-content--left" v-if="!profileTab && !cpnDetail">
                <input type="text" autocomplete="off" v-model="keyword" :placeholder="$t('manage_student.keyWord')" class="input--search-content--left" />
            </div>
        </div>
        
        <!-- Lọc -->
        <div v-if="!profileTab && !cpnDetail" :class="{controlType: !mobile }">
            <div class="select-new select-custom nqt__ujd" :class="{mobile: mobile}">
                <select v-model="type">
                    <option :value="99">{{$t('manage.default')}}</option>
                    <option :value="true">{{$t('manage_student.charge')}}</option>
                    <option :value="false">{{$t('manage_student.not_charge')}}</option>
                </select>
            </div>
            <div class="noteDot dtp">
                <span class="menu-switch-school lesson_begin" :value="lessonBegin" :class="{ 'menu-switch-school-on': lessonBegin }" @click="lessonBegin = !lessonBegin"></span>
                <span @click="lessonBegin = !lessonBegin">{{$t('week.undone')}}</span>
                <span class="menu-switch-school lesson_learning" :value="lessonLearning" :class="{ 'menu-switch-school-on': lessonLearning }" @click="lessonLearning = !lessonLearning"></span>
                <span @click="lessonLearning = !lessonLearning">{{$t('week.studing')}}</span>
                <span class="menu-switch-school lesson_end" :value="lessonEnd" :class="{ 'menu-switch-school-on': lessonEnd }" @click="lessonEnd = !lessonEnd"></span>
                <span @click="lessonEnd = !lessonEnd">{{$t('week.done')}}</span>
            </div>
        </div>

        <!-- Danh sách khóa học -->
        <template v-if="!profileTab">
            <div class="nqt-list-study" v-show="!cpnDetail" ref="lessons">
                <template v-for="(item, index) in lessons">
                  <div class="nqt--card--student" v-if="checkStatusLesson(item.statusLesson, item.courseName) && checkTeacher(item.teacherList)" v-on:click="detail({course: item, user: data})" :class="[{stBg: item.statusLesson == 0}, {stLn: item.statusLesson == 1}, {stEnd: item.statusLesson == 2}, {tooltip: !mobile}]" :key="index">
                      <h1 class="nqt--card-title">{{item.courseName}}</h1>
                      <div class="box-ttct">
                        <div class="card-avtar">
                            <div class="next_page_details">
                              <img v-if="item.courseCover != '' && item.courseCover != null" class="avatar-hv" :src="item.courseCover" alt="courseCover">
                              <img v-else class="avatar-hv" src="../../../../static/images/temppic.jpg" alt="courseCover">
                            </div>
                        </div>
                        <div class="card-tt">

                          <span class="nqt--card-discription" style="-webkit-box-orient: vertical !important;" :class="[{uio9: !mobile && checkHeight(item.synopsis) }, {uinqt: !mobile}]" >
                              <span v-if="!mobile" class="tooltiptext pjjj__nqt" v-html="item.synopsis"></span><span v-html="item.synopsis"></span>
                          </span>

                          <span class="nqt--card-discription">
                              <b>{{$t('manage_student.time')}}:</b> {{item.startDate}} <template v-if="item.startDate && item.endDate">～</template> {{item.endDate}}
                          </span>

                          <span class="nqt--card-discription">
                              <b>{{$t('manage_student.count_of_students')}}:</b><template v-if="item.totalStudent != null"> {{item.totalStudent}}</template>
                          </span>

                          <span class="nqt--card-discription" :class="[{uio9: !mobile && item.teacherList != null ? item.teacherList.length > 2 : false }]" style="-webkit-box-orient: vertical !important;">
                            <!-- Mobile -->
                            <span class="tooltiptext lkt-tooltip" v-if="!mobile">
                              <template v-for="(teacher, i) in item.teacherList">
                                <i :class="{isTeacher: teacher.id == teacherId}" :key="i"><template v-if="i != 0">, </template>
                                  <template v-if="teacher.userName != null && teacher.userName.search('@') !== -1">{{teacher.userName.substring(0, teacher.userName.search('@'))}}</template>
                                  <template v-if="teacher.userName != null && teacher.userName.search('@') == -1">{{teacher.userName}}</template>
                                </i>
                              </template>
                            </span>
                            <!-- PC -->
                            <span class="lkt-hiddenText" style="-webkit-box-orient: vertical !important;">
                              <b>{{$t('manage_student.teacher')}}:</b>
                              <template v-for="(teacher, i) in item.teacherList">
                                <i :class="{isTeacher: teacher.id == teacherId}" :key="i"><template v-if="i != 0">, </template>
                                  <template v-if="teacher.userName != null && teacher.userName.search('@') !== -1">{{teacher.userName.substring(0, teacher.userName.search('@'))}}</template>
                                  <template v-if="teacher.userName != null && teacher.userName.search('@') == -1">{{teacher.userName}}</template>
                                </i>
                              </template>
                            </span>
                          </span>

                          <span class="nqt--card-discription">
                            <b>{{$t('manage_student.status')}}:</b>
                            {{getNameStatus(parseInt(item.status))}}
                          </span>
                        </div>
                      </div>
                  </div>
                </template>
            </div>
        </template>

        <!-- Nội dung:Profile -->
        <template v-if="!loading">
            <profile v-if="profileTab && !cpnDetail" :data="{user: data, courses: results}" @jump="jump($event)"></profile>
        </template>

        <!-- Component: Chi tiết khóa học -->
        <detail v-if="cpnDetail" :data="detailData" v-on:clickShowWrongExamDt="clickShowWrongExamDt($event)"></detail>

        <!-- Loading -->
        <loading class="loading--lesson nqt-pst-a" :showLoading="loading"/>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import statictical from "@/components/manage/statictical";
    import question from "@/components/manage/question";
    import detail from "@/components/manage/detail/content";
    import profile from "@/components/manage/profile";
    import loading from "@/components/loading/loading";

    export default {
        data() {
            return {
                loading: true,
                profileTab: true,
                show: false,
                keyword: null,
                results: [],
                lessonBegin: true,
                lessonLearning: true,
                lessonEnd: true,
                type: 99,
                teacherId: null,
                showWrongExam: false,
                course: null,
            };
        },
        components: {
            statictical,
            question,
            detail,
            profile,
            loading,
        },
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        computed: {
            // Tìm kiếm khóa học
            lessons: function () {
                let keyword = this.keyword;
                let result = [];

                if (keyword == null || keyword == "") {
                    result = this.results;
                } else {
                    keyword = keyword.toUpperCase();
                    result = this.results.filter(lesson => lesson.courseName.toUpperCase().indexOf(keyword) > -1 || lesson.synopsis.toUpperCase().indexOf(keyword) > -1);
                }
                return result;
            },

            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
                cpnDetail: (state) => state.manageStudent.showDetail,
                showWrongAnswer: (state) => state.manageDetail.showWrongAnswer
            }),
        },
        created() {
            this.init();
        },
        methods: {
            init: async function () {
                this.loading = true;
                this.teacherId = this.$attrs.userId || window.sessionStorage.getItem("id");
                this.setShowDetail(false);
                this.setShowWrongAnswer(false);

                // Lấy danh sách khóa học
                this.results = await this.getAllStudent();

                if (this.$route.query.exam != null && this.$route.query.exam != undefined) {
                    let lesson =  this.results.findIndex(lesson => lesson.courseId == this.$route.query.courseId)
                    if (lesson >= 0) {
                        await this.detail({course:  this.results[lesson], user: this.data});
                    }
                }

                // Hiển thị component
                this.loading = false;
            },

            // Lấy tất cả khóa học của học viên
            getAllStudent: function () {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getAllCoursesByStudent", {
                          studentId: this.data.id
                        })
                        .then((response) => {
                            // Biểu thức Regex check chuỗi bắt đầu http:// hoặc https://
                            let regex = new RegExp(/^\[LiveStream\]\r\n(http:\/\/|https:\/\/).*$/);

                            const courses = response.data.reduce((accumulator, value) => {
                                let status = 0;
                                status = value.startStudyDate != null ? 1 : status;
                                status = value.startStudyDate != null && value.endStudyDate != null ? 2 : status;
                                value['statusLesson'] = status;
                                if (regex.test(value.synopsis)) {
                                  value.synopsis = "[LiveStream]";
                                }
                                accumulator.push(value);
                                return accumulator;
                            }, []);
                            resolve(courses);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Đến trnag chi tiết khóa học
            detail: function (data) {
              this.$api
              .post("/courseStudy/getCourseSubOutlineListByTopOutline", {
                  courseId: data.course.courseId,
                  userId: data.user.id,
              })
              .then((response) => {
                  if (response.data.length == 0) {
                      this.$confirm(window.vm.$i18n.t("new.title108"), window.vm.$i18n.t("new.title86"), { cancelButtonClass: "btn-nqt---show" })
                          .then(() => {})
                          .catch(() => {});
                      return;
                  } else {
                      this.course = data.course;
                      this.detailData = {courseId: data.course.courseId, studentId: data.user.id, courseName: data.course.courseName}
                      this.setShowDetail(true);
                      this.setShowWrongAnswer(false);
                  }
              });
            },

            // export certificate for student
            exportCertificate () {
                if(this.course.startStudyDate == null && parseInt(this.course.status) == this.$CONST.CURRICULUM_EXAM.STATUS.MIDTERM.NOT_START_OR_SUCCESS) {
                    return this.$message.warning(window.vm.$i18n.t("manage.msgExportCer"));
                }
                this.$api
                    .post("/home/certificateExport", {
                        id              : this.course.courseId,
                        courseName      : this.course.courseName,
                        courseLanguage  : this.$lang(),
                        area            : this.$lang(),
                        name            : this.data.userName,
                        gender          : this.data.sex,
                        companyId       : window.sessionStorage.getItem("companyId"),
                        jobs            : this.data.job
                    })
                    .then((response) => {
                        if (response.data != null) {
                            window.open(response.data);
                        } else {
                            this.$message.warning(window.vm.$i18n.t("js.certificateDataNone"));
                        }
                    })
                    .catch((error) => {});
            },

            // Quay lại
            back: function () {
              if (this.showWrongAnswer) {
                this.setShowWrongAnswer(false);
              } else {
                this.setShowDetail(false);
              }
            },

            ...mapMutations("manageStudent", ["setShowDetail"]),
            ...mapMutations("manageDetail", ["setShowWrongAnswer"]),

            // Tooltip
            checkHeight: function (text) {
              let status = false;
              if (this.$lang() == 3 && text.length > 73) {
                  status = true;
              }
              if (this.$lang() == 4 && text.length > 123) {
                status = true;
              }
              if (this.hasKanji(text) && text.length > 73) {
                status = true;
              }
              return status;
            },

            isKanji: function (ch) {
                return (ch >= "\u4e00" && ch <= "\u9faf") ||
              (ch >= "\u3400" && ch <= "\u4dbf");
            },

            some: function (str, callback) {
                return Array.prototype.some.call(str, callback);
            },

            hasKanji: function (str) {
                return this.some(str, this.isKanji);
            },

            // Đến danh sách khóa học ứng với loại
            jump: function (result) {
                switch (result) {
                  case 0:
                    this.lessonBegin = true;
                    this.lessonLearning = false;
                    this.lessonEnd = false;
                    break;
                  case 1:
                    this.lessonBegin = false;
                    this.lessonLearning = true;
                    this.lessonEnd = false;
                    break;
                  case 2:
                    this.lessonBegin = false;
                    this.lessonLearning = false;
                    this.lessonEnd = true;
                    break;
                  default:
                    this.lessonBegin = true;
                    this.lessonLearning = true;
                    this.lessonEnd = true;
                    break;
                }

                this.type = 99;
                this.profileTab = true;
                this.loading = true;
                this.$nextTick(() => {
                    setTimeout(() => {
                      this.profileTab = false;
                      this.loading = false;
                    }, 100);
                });

            },

            // Kiểm tra trạng thái khóa học đối với học viên
            checkTeacher:  function (data) {
              let teacherList = [];
              if (data != null) {
                teacherList = data.filter(lesson => lesson.id == this.teacherId);
              }
              let result = false;
              if (this.type == 99) {
                result = true;
              }

              if (this.type && teacherList.length) {
                result = true;
              }
              return result;
            },

            // Kiểm tra trạng thái khóa học đối với học viên
            checkStatusLesson:  function (status, name) {
              let result = false;
              if (this.lessonBegin && this.lessonLearning && this.lessonEnd) {
                result = true;
              }

              if (!this.lessonBegin && !this.lessonLearning && !this.lessonEnd) {
                result = false;
              }

              if (!this.lessonBegin && this.lessonLearning && this.lessonEnd && status != 0) {
                result = true;
              }

              if (this.lessonBegin && !this.lessonLearning && this.lessonEnd && status != 1) {
                result = true;
              }

              if (this.lessonBegin && this.lessonLearning && !this.lessonEnd && status != 2) {
                result = true;
              }

              if (this.lessonBegin && !this.lessonLearning && !this.lessonEnd && status == 0) {
                result = true;
              }

              if (!this.lessonBegin && this.lessonLearning && !this.lessonEnd && status == 1) {
                result = true;
              }

              if (!this.lessonBegin && !this.lessonLearning && this.lessonEnd && status == 2) {
                result = true;
              }
              return result;
            },
            
            // Lấy về trạng thái của học viên đối với khóa học
            getNameStatus: function (params) {
              var name = "";
              switch (params) {
                case -1:
                  name = this.$t('manage_student.exam_not_me');
                  break;
                case 0:
                  name = this.$t('manage_student.lesson_unlocked');
                  break;
                case 1:
                  name = this.$t('manage_student.lesson_locked_not_study_end');
                  break;
                case 2:
                  name = this.$t('manage_student.lesson_study_end_not_exam');
                  break;
                case 3:
                  name = this.$t('manage_student.lesson_exam_doing');
                  break;
                case 4:
                  name = this.$t('manage_student.lesson_exam_end');
                  break;
                case 5:
                  name = this.$t('manage_student.lesson_unpass');
                  break;
                case 6:
                  name = this.$t('manage_student.lesson_pass');
                  break;
                case 7:
                  name = this.$t('manage_student.lesson_tuyet_doi');
                  break;
                case 99:
                  name = this.$t('manage_student.lesson_end');
                  break;
                default:
                  break;
              }
              return name;
            },
            clickShowWrongExamDt(params) {
              this.showWrongExam = params.showTypeWrongExam;
            }
        },
    };
</script>
<style scoped>
    .content__buttons {
      display: flex;
    }
    .manage--search-content--left input {
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        width: 100%;
    }
    .card-avtar {
        width: 160px;
    }
    .card-tt {
        width: calc(100% - 160px);
    }
    .lkt-hiddenText {
        display: -webkit-box !important;
        -webkit-box-orient: vertical !important;
        -webkit-line-clamp: 1 !important;
    }
    .nqt--card-discription {
        display: -webkit-box !important;
        -webkit-box-orient: vertical !important;
        padding: 0 0 0px !important;
        overflow: hidden !important;
        color: #333 !important;
        -webkit-line-clamp: 3 !important;
        line-height: 18px;
        width: 100%;
        margin-bottom: 5px;
    }
    .nqt--card--student {
        cursor: pointer;
        border: 1px solid #d7d7d7;
        /* min-height: 300px; */
    }
    .nqt--card-discription i {
        font-style: unset;
    }
    .nqt--card-discription i.isTeacher {
        color: #00a8ff;
    }
    .nqt--title {
        text-align: center;
        /* margin: 10px auto; */
        text-transform: uppercase;
        height: 36px;
        padding: 2px;
    }
    .stBg .nqt--card-title {
        color: #1f1313;
    }
    .stLn .nqt--card-title {
        color: #da251d;
    }
    .stEnd .nqt--card-title {
        color: #118e07;
    }
    .unactive {
        filter: grayscale(100%);
    }
    .select-new {
        width: 25% !important;
    }
    .select-new.mobile {
        width: 100% !important;
        margin-top: 1rem;
    }
    .dtp {
        margin-top: 20px;
        float: none;
    }
    .dot--lesson_begin {
        background: #1f1313;
    }
    .dot--lesson_learning {
        background: #da251d;
    }
    .dot--lesson_end {
        background: #118e07;
    }

    .noteDot span {
        padding-left: 10px;
        padding-right: 20px;
        cursor: pointer;
        font-size: 15px;
    }

    /* switch */
    .menu-switch-school {
        display: block;
        position: relative;
        width: 46px;
        height: 27px;
        border: 1px solid #dfdfdf;
        outline: 0;
        border-radius: 16px;
        box-sizing: border-box;
        background-color: #dfdfdf;
        transition: background-color 0.1s, border 0.1s;
        cursor: pointer;
    }
    .menu-switch-school:before {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 44px;
        height: 25px;
        border-radius: 15px;
        transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
    }
    .menu-switch-school:after {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 24px;
        height: 24px;
        border-radius: 15px;
        background-color: #ffffff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
        transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
    }
    .menu-switch-school-on {
        border-color: #79c9ff;
        background-color: #79c9ff;
    }
    .lesson_begin.menu-switch-school-on:before {
        border-color: #1f1313;
        background-color: #1f1313;
    }
    .lesson_learning.menu-switch-school-on:before {
        border-color: #da251d;
        background-color: #da251d;
    }
    .lesson_end.menu-switch-school-on:before {
        border-color: #118e07;
        background-color: #118e07;
    }
    .menu-switch-school-on:after {
        transform: translateX(20px);
    }
    .controlType {
        display: flex;
    }
    .controlType .dtp {
        margin-top: 0;
        margin-left: 20px;
    }
    .loading--lesson {
        position: absolute;
    }
    /* toptip */
    /* Tooltip container */
    .tooltip {
        position: relative;
        display: inline-block;
    }

    /* Tooltip text */
    .tooltip .tooltiptext {
        visibility: hidden;
        width: auto;
        background-color: black;
        color: #fff;
        text-align: center;
        padding: 5px;
        border-radius: 6px;

        /* Position the tooltip text - see examples below! */
        position: absolute;
        z-index: 1;
        top: 40%;
        right: 0;
        left: 0;
    }

    .tooltip .lkt-tooltip {
        top: 83%;
        left: 43%;
        visibility: hidden;
        width: auto;
        background-color: black;
        color: #fff;
        text-align: center;
        padding: 5px;
        border-radius: 6px;

        /* Position the tooltip text - see examples below! */
        position: absolute;
        z-index: 1;
    }

    .tooltip .tooltiptext::after {
        content: " ";
        position: absolute;
        bottom: 100%; /* At the top of the tooltip */
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent black transparent;
    }

    /* Show the tooltip text when you mouse over the tooltip container */
    .uio9:hover .tooltiptext {
        visibility: visible;
    }
    .uio9 {
        -webkit-box-orient: vertical !important;
    }
    .uinqt {
        height: 54px;
    }
    .imgf {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .tooltiptext.pjjj__nqt {
        text-align: unset !important;
    }
    .tooltiptext.lkt-tooltip {
        text-align: unset !important;
    }
    .nqt-pst-a {
        position: absolute !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/manage/content/students.vue